export function GetRequest() {
  // let url = location.href.split("?")[1].split("&"); //获取url中"?"符后的字串

  let test = location.href.split("?")[1] //获取url中"?"符后的字串
  if (test) {
    let url = test.split("&")
    let query = {};
    url.forEach(item => {
      query[item.split("=")[0]] = decodeURIComponent(item.split("=")[1]);  //转码
    });
    return query;
  }
}